<div class="exception-body notfound">
    <div class="exception-content">
        <div class="maintenance-exception-title">{{'UnderMaintenance' | translate | uppercase }}</div>
        <div class="exception-detail">{{'WeAreWorkingForYourBetterExperience' | translate }}</div>
    </div>
</div>
